import React, { useEffect, useState } from "react";
import { AvForm } from "availity-reactstrap-validation";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {
  Card,
  CardBody,
  Col,
  Container,
  Button,
  Row,
  Label,
  Form,
  CardImg,
} from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import Dropzone from "react-dropzone";
import Select from "react-select";
import moment from "moment";
import { Link } from "react-router-dom";
import _ from "lodash";
import { FaPen , FaRegTrashAlt, FaPlus, FaCloudUploadAlt} from "react-icons/fa";

const AddMenuLabel = (props) => {
  const statusOptions = [
    { value: "Y", label: "Enable" },
    { value: "N", label: "Disable" },
  ];

  const ServiceTypeOptions = [
    { label: "Makan Master", value: "makan-master" },
    { label: "End of Trip", value: "endoftrip" },
    { label: "Events", value: "events" },
    { label: "Facilities", value: "facilities" },
  ];

  const [label, setLabel] = useState();
  const [imageUrl, setImageUrl] = useState();
  const [unselectedImageUrl,setUnselectedImageUrl]=useState()
  const [sort, setSort] = useState();
  // const [status, setStatus] = useState(statusOptions[0].value);
  const [successAlert, setSuccesAlert] = useState(false);
  const [errorAlert, setErrorAlert] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [token, setToken] = useState();
  const [propsData, setPropsData] = useState(props?.location?.state);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [unSelectedFiles, setUnSelectedFiles] = useState([]);


  useEffect(() => {
    const token = localStorage.getItem("AuthenticationToken");
    setToken(token);

    if (props.location.state?.edit) {
      setPropsData(props?.location?.state);
      var label = props.location.state?.item?.item_name;
      var imageUrl = props.location.state?.item?.userfile;
      var unselectedImageUrl=props.location.state?.item?.unselectedFile
      var sort = props.location.state?.item?.sort_order;
      // var status = props.location.state?.item?.item_status;

      setLabel(label);
      setImageUrl(imageUrl);
      setUnselectedImageUrl(unselectedImageUrl)
      setSort(sort);
      // setStatus(status);
    }
  }, []);

  const  handleSubmit = async() => {
    if (!label) {
      setErrorMessage("Please Enter label");
      setErrorAlert(true);
      return;
    }
    else if (!sort) {
      setErrorMessage("Please Enter Position");
      setErrorAlert(true);
      return;
    }else if(selectedFiles.length<=0){
      setErrorMessage("Please Choose Seleceted Image");
      setErrorAlert(true);
      return;
    }else if(unSelectedFiles.length<=0){
      setErrorMessage("Please Choose Unseleceted Image");
      setErrorAlert(true);
      return;
    }
    let currentDate = moment(new Date()).format("YYYY/MM/DD HH:mm");
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append("cache-control", "no-cache");
    myHeaders.append(
      "Cookie",
      "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208"
    );

    var formdata = new FormData();
    formdata.append("path", "menu_labels/add");
    formdata.append("item_type", "menu_labels");
    formdata.append("created_datetime", currentDate);
    formdata.append("item_name",label)
    formdata.append("sort_order", sort);
    
    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
      processData: false,
      mimeType: "multipart/form-data",
      async: true,
      crossDomain: true,
    };

       await fetch(`${process.env.REACT_APP_TOKRI_API_URL}/api/frhub`, requestOptions)
      .then(async(response) => {
        const respArray = await  response.json()
        const getUser = await _.orderBy(respArray.Items, ["created_datetime"], ["desc"]);
        var itemId=getUser[0].item_id
        if(itemId){
         handleEdit(itemId)
        }
      })
      .catch((error) => {
        console.log("here come error--->", error);
      });
  };

  const handleEdit = (itemid = '') => {
    if (!label) {
      setErrorMessage("Please Enter sort label");
      setErrorAlert(true);
      return;
    }
    else if (!sort) {
      setErrorMessage("Please Enter Position");
      setErrorAlert(true);
      return;
    }
    else if(selectedFiles.length<=0){
      if(!imageUrl){
        setErrorMessage("Please Choose Seleceted Image");
        setErrorAlert(true);
        return;
      }
    }else if(unSelectedFiles.length<=0){
      if(!unselectedImageUrl){
        setErrorMessage("Please Choose Unseleceted Image");
        setErrorAlert(true);
        return;
      }

    }
    // let currentDate = moment(new Date()).format("YYYY/MM/DD HH:mm")
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append("cache-control", "no-cache");
    myHeaders.append(
      "Cookie",
      "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208"
    );

    var formdata = new FormData();
    if(itemid !=''){
      formdata.append("item_id", itemid);
    }else{
      formdata.append("item_id", propsData?.item?.item_id);
    }
    formdata.append("item_type", "menu_labels");
    formdata.append("path", "menu_labels/update");
    if (!imageUrl) {
      formdata.append("userfile", selectedFiles[0], selectedFiles[0].path);
    }
    if(!unselectedImageUrl){
      formdata.append("unselectedFile", unSelectedFiles[0], unSelectedFiles[0].path);
    }
    formdata.append("item_name",label)
    formdata.append("sort_order", sort);
    formdata.append("item_status","Y");
    // formdata.append("image_url",imageUrl);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
      processData: false,
      mimeType: "multipart/form-data",
      async: true,
      crossDomain: true,
    };

    fetch(`${process.env.REACT_APP_TOKRI_API_URL}/api/frhub`, requestOptions)
      .then((response) => {
        if (response.status == 200) {
          console.log("here is the res", response);
          setSuccesAlert(true);
        } else {
          setErrorMessage("Unable to Add");
          setErrorAlert(true);
        }
        console.log("here is the res", response);
      })
      .catch((error) => {
        console.log("here come error--->", error);
      });
  };

  const renderSuccessAlert = () => {
    return (
      <SweetAlert
        title="Success!"
        success
        confirmBtnBsStyle="success"
        onConfirm={() => {
          props?.history.push("/menu_labels");
          setSuccesAlert(false);
        }}
        onCancel={() => {
          setSuccesAlert(false);
        }}
      >
        {props?.location?.state?.edit ? "Menu Label updated": "Menu lable Added"}
      </SweetAlert>
    );
  };

  const renderFailureAlert = () => {
    return (
      <SweetAlert
        title="Warning!"
        warning
        confirmBtnBsStyle="warning"
        onConfirm={() => {
          setErrorAlert(false);
        }}
      >
        {errorMessage ? errorMessage : "Error. Something went wrong."}
      </SweetAlert>
    );
  };

  /**
   * Formats the size
   */
  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

  function handleAcceptedFiles(files) {
    files.map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    );
    let path = files[0].path;
    path = path.split(".");
    path = path[1];
    if (
      path == "jpg" ||
      path == "jpeg" ||
      path == "JPEG" ||
      path == "JPG" ||
      path == "png" ||
      path == "PNG"
    ) {
      setSelectedFiles(files);
      setImageUrl("");
    } else {
      setErrorMessage("Please select a .jpg or .png file");
      setErrorAlert(true);
    }
  }

  function handleAcceptedFiles2(files) {
    files.map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    );
    let path = files[0].path;
    path = path.split(".");
    path = path[1];
    if (
      path == "jpg" ||
      path == "jpeg" ||
      path == "JPEG" ||
      path == "JPG" ||
      path == "png" ||
      path == "PNG"
    ) {
      setUnSelectedFiles(files);
      setUnselectedImageUrl("");
    } else {
      setErrorMessage("Please select a .jpg or .png file");
      setErrorAlert(true);
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs breadcrumbItem={props.location?.state?.edit ? "Edit Menu Label":"Add Menu Label"} />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AvForm className="needs-validation">
                    <Card>
                      <CardBody>
                        <Row>
                          <Col lg={4} md={10} sm={10}>
                            <div className="mb-3">
                              <Label>Label Name</Label>
                              <input
                                type="text"
                                className="form-control"
                                id="label_name_input"
                                onChange={(e) => {
                                  setLabel(e.target.value);
                                }}
                                defaultValue={label}
                              />
                            </div>
                          </Col>
                          <Col lg={1}></Col>
                          <Col lg={4} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>Position</Label>
                              <div className="col-md-12">
                                <input
                                  className="form-control"
                                  onChange={(e) => {
                                    setSort(e.target.value);
                                  }}
                                  type="number"
                                  id="sort_input"
                                  defaultValue={sort}
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={12} md={12} sm={12}>
                            {/* <Card>
                              <CardBody> */}
                            <Row className="mt-3">
                              <Col lg={4} md={6}>
                                <Label>Selected Image</Label>
                                <Form
                                  style={{
                                    background: "#eeeeee",
                                    borderRadius: "20px",
                                  }}
                                >
                                  {imageUrl && (
                                    <Row>
                                      <Col lg={3} className="p-3">
                                        <CardImg
                                          className="img-fluid"
                                          src={imageUrl}
                                          style={{
                                            marginBottom: 10,
                                            width: "60px",
                                          }}
                                          alt=""
                                        />
                                      </Col>
                                      <Col
                                        style={{
                                          marginTop: "auto",
                                          marginBottom: "auto",
                                        }}
                                      >
                                        <div
                                          className="px-3 text-danger"
                                          style={{ cursor: "pointer" }}
                                          onClick={() => {
                                            setImageUrl("");
                                          }}
                                        >
                                          <FaRegTrashAlt />
                                          Move To Trash
                                        </div>
                                      </Col>
                                    </Row>
                                  )}
                                  <Dropzone
                                    onDrop={(acceptedFiles) => {
                                      // validateFileSize(acceptedFiles)
                                      handleAcceptedFiles(acceptedFiles);
                                    }}
                                  >
                                    {({ getRootProps, getInputProps }) => (
                                      <div
                                        className="dropzone"
                                        style={{ padding: "10px" }}
                                      >
                                        <div
                                          className="dz-message needsclick"
                                          {...getRootProps()}
                                        >
                                          <input {...getInputProps()} />
                                          <div className="mb-3">
                                            <FaCloudUploadAlt className="display-4 text-muted"/>
                                          </div>
                                          <h5>
                                            Drop files here or click to upload.
                                          </h5>

                                          <p
                                            style={{
                                              fontSize: 12,
                                              color: "red",
                                            }}
                                          >
                                            
                                          </p>
                                        </div>
                                      </div>
                                    )}
                                  </Dropzone>
                                  <div
                                    className="dropzone-previews mt-3"
                                    id="file-previews"
                                  >
                                    {selectedFiles.map((f, i) => {
                                      return (
                                        <Card
                                          className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                          key={i + "-file"}
                                        >
                                          <div className="p-2">
                                            <Row className="align-items-center">
                                              <Col className="col-auto">
                                                <img
                                                  data-dz-thumbnail=""
                                                  height="80"
                                                  className="avatar-sm rounded bg-light"
                                                  alt={f.name}
                                                  src={f.preview}
                                                />
                                              </Col>
                                              <Col>
                                                <Link
                                                  to="#"
                                                  className="text-muted font-weight-bold"
                                                >
                                                  {f.name}
                                                </Link>
                                                <p className="mb-0">
                                                  <strong>
                                                    {f.formattedSize}
                                                  </strong>
                                                </p>
                                              </Col>
                                            </Row>
                                          </div>
                                        </Card>
                                      );
                                    })}
                                  </div>
                                </Form>
                              </Col>
                              <Col lg={1}></Col>
                              <Col lg={4} md={6}>
                                <Label> Un Selected Image</Label>
                                <Form
                                  style={{
                                    background: "#eeeeee",
                                    borderRadius: "20px",
                                  }}
                                >
                                  {unselectedImageUrl && (
                                    <Row>
                                      <Col lg={3} className="p-3">
                                        <CardImg
                                          className="img-fluid"
                                          src={unselectedImageUrl}
                                          style={{
                                            marginBottom: 10,
                                            width: "60px",
                                          }}
                                          alt=""
                                        />
                                      </Col>
                                      <Col
                                        style={{
                                          marginTop: "auto",
                                          marginBottom: "auto",
                                        }}
                                      >
                                        <div
                                          className="px-3 text-danger"
                                          style={{ cursor: "pointer" }}
                                          onClick={() => {
                                            setUnselectedImageUrl("");
                                          }}
                                        >
                                          <FaRegTrashAlt />
                                          Move To Trash
                                        </div>
                                      </Col>
                                    </Row>
                                  )}
                                  <Dropzone
                                    onDrop={(acceptedFiles) => {
                                      // validateFileSize(acceptedFiles)
                                      handleAcceptedFiles2(acceptedFiles);
                                    }}
                                  >
                                    {({ getRootProps, getInputProps }) => (
                                      <div
                                        className="dropzone"
                                        style={{ padding: "10px" }}
                                      >
                                        <div
                                          className="dz-message needsclick"
                                          {...getRootProps()}
                                        >
                                          <input {...getInputProps()} />
                                          <div className="mb-3">
                                            <FaCloudUploadAlt className="display-4 text-muted"/>
                                          </div>
                                          <h5>
                                            Drop files here or click to upload.
                                          </h5>

                                          <p
                                            style={{
                                              fontSize: 12,
                                              color: "red",
                                            }}
                                          >
                                            
                                          </p>
                                        </div>
                                      </div>
                                    )}
                                  </Dropzone>
                                  <div
                                    className="dropzone-previews mt-3"
                                    id="file-previews"
                                  >
                                    {unSelectedFiles.map((f, i) => {
                                      return (
                                        <Card
                                          className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                          key={i + "-file"}
                                        >
                                          <div className="p-2">
                                            <Row className="align-items-center">
                                              <Col className="col-auto">
                                                <img
                                                  data-dz-thumbnail=""
                                                  height="80"
                                                  className="avatar-sm rounded bg-light"
                                                  alt={f.name}
                                                  src={f.preview}
                                                />
                                              </Col>
                                              <Col>
                                                <Link
                                                  to="#"
                                                  className="text-muted font-weight-bold"
                                                >
                                                  {f.name}
                                                </Link>
                                                <p className="mb-0">
                                                  <strong>
                                                    {f.formattedSize}
                                                  </strong>
                                                </p>
                                              </Col>
                                            </Row>
                                          </div>
                                        </Card>
                                      );
                                    })}
                                  </div>
                                </Form>
                              </Col>
                            </Row>
                            {/* </CardBody>
                            </Card> */}
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                    <div style={{ textAlign: "right" }} className="btn-sec">
                      <Button
                        onClick={() => {
                          props.history.push("/menu_labels");
                        }}
                        color="danger"
                        type="submit"
                      >
                        {" "}
                        Cancel
                      </Button>
                      <Button
                        onClick={() => {
                          if (props?.location?.state?.edit) {
                            handleEdit();
                          } else {
                            handleSubmit();
                          }
                        }}
                        style={{ marginLeft: "10px" }}
                        // className="px-4"
                        color="success"
                        type="submit"
                      >
                        Save
                      </Button>
                    </div>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {successAlert ? renderSuccessAlert() : null}
          {errorAlert ? renderFailureAlert() : null}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default AddMenuLabel;
